import {
  CNPJ_BASE_VALUE,
  CNPJ_NO_VD_LENGTH,
  CNPJ_ONLY_ZEROS,
  CNPJ_WEIGHTS,
  DOCUMENT_LENGTH_WITHOUT_MASK,
  CPF_MASK_REGEX,
  CNPJ_MASK_REGEX,
} from '../constants/cpfCnpj';
import functions from '../utils/functions';

export default {
  validaCpf(cpf) {
    let soma = 0;
    for (let i = 0; i < 9; i++) {
      soma += parseInt(cpf.charAt(i)) * (10 - i);
    }
    let resto = 11 - (soma % 11);
    if (resto === 10 || resto === 11) resto = 0;
    if (resto !== parseInt(cpf.charAt(9))) return false;

    soma = 0;
    for (let i = 0; i < 10; i++) {
      soma += parseInt(cpf.charAt(i)) * (11 - i);
    }
    resto = 11 - (soma % 11);
    if (resto === 10 || resto === 11) resto = 0;
    return resto === parseInt(cpf.charAt(10));
  },

  valida_cpf_cnpj(valor) {
    if (!CPF_MASK_REGEX.test(valor) && !CNPJ_MASK_REGEX.test(valor)) {
      return false;
    }
    const noMaskDocument = functions.removeSpecialCharacters(valor);
    if (noMaskDocument.length === DOCUMENT_LENGTH_WITHOUT_MASK.CPF) {
      return this.validaCpf(noMaskDocument);
    } else if (noMaskDocument.length === DOCUMENT_LENGTH_WITHOUT_MASK.CNPJ) {
      return this.validaCnpj(noMaskDocument);
    } else {
      return false;
    }
  },

  calculateVerificationDigits(noVDCnpj) {
    if (noVDCnpj === CNPJ_ONLY_ZEROS.substring(0, CNPJ_NO_VD_LENGTH)) {
      return '';
    }

    let firstSum = 0;
    let secondSum = 0;
    for (let i = 0; i < CNPJ_NO_VD_LENGTH; i++) {
      const ascii = noVDCnpj.charCodeAt(i) - CNPJ_BASE_VALUE;
      firstSum += ascii * CNPJ_WEIGHTS[i + 1];
      secondSum += ascii * CNPJ_WEIGHTS[i];
    }
    const firstVD = firstSum % 11 < 2 ? 0 : 11 - (firstSum % 11);
    secondSum += firstVD * CNPJ_WEIGHTS[CNPJ_NO_VD_LENGTH];
    const secondVD = secondSum % 11 < 2 ? 0 : 11 - (secondSum % 11);
    return `${firstVD}${secondVD}`;
  },

  validaCnpj(cnpj) {
    if (cnpj === CNPJ_ONLY_ZEROS) {
      return false;
    }

    const noVDCnpj = cnpj.slice(0, CNPJ_NO_VD_LENGTH);
    const informedVD = cnpj.slice(CNPJ_NO_VD_LENGTH);
    const calculatedVD = this.calculateVerificationDigits(noVDCnpj);

    return informedVD === calculatedVD;
  },
};
